import { PdvService } from './../../../services/pdv/pdv.service';
import { Subscription } from 'rxjs';
import { Component } from '@angular/core';
declare var window:any;

@Component({
    selector: 'legal-notice',
    templateUrl: 'legal-notice.component.html',
    styleUrls: ['legal-notice.component.scss']
})
export class LegalNoticeComponent {
    
    restaurant:"";
    website:"";
    address:"";
    phone:"";
    email:"";
    subscriptions: Subscription[] = [];
    constructor(private pdvService: PdvService){
        const sub = this.pdvService.pdv.subscribe(pdv => {
            this.address = pdv.address;
            this.restaurant = pdv.name;
            this.phone = pdv.phone;
            this.email = pdv.emailContact;
            this.website= window.location.hostname;
        });
        this.subscriptions.push(sub);
    }

    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    ngOnDestroy() {
        this.unsubscribe();
    }
}
